<template>
  <ul class="controlbox">
    <li>
      <div
        @click="choiceDynamicAreaByPlanid('计划关联空域')"
        :class="
          DynamicAreaByPlanidActive === '计划关联空域'
            ? 'link featureControl featureactive'
            : 'link featureControl featureControl'
        "
      >
        涉及动态空域
      </div>
      <div
        v-if="infoData.flightmissionid"
        @click="choiceTaskAreaByPlanid('任务关联空域')"
        :class="
          TaskAreaByPlanidActive === '任务关联空域'
            ? 'link featureControl featureactive '
            : 'link featureControl featureControl '
        "
      >
        计划关联任务
      </div>
      <div
        @click="choiceAirportControlZoneByPlanid('计划关联管制区')"
        :class="
          AirportControlZoneByPlanidActive === '计划关联管制区'
            ? 'link featureControl featureactive '
            : 'link featureControl featureControl '
        "
      >
        涉及空军管制区
      </div>
      <div
        @click="choiceBranchAirportByPlanid('计划关联管制区')"
        :class="
          BranchAirportByPlanidActive === '计划关联管制区'
            ? 'link featureControl featureactive '
            : 'link featureControl featureControl '
        "
      >
        涉及民航管制区
      </div>
    </li>
  </ul>
</template>

<script>
import { ws, yunxiangHost } from "../utils/config";

import { mapGetters, mapActions } from "vuex";

import {
  getDynamicAreaByPlanid,
  getAirportControlZoneByPlanid,
  getTaskDetail,
  getBranchAirportByPlanid,
} from "../request/api";

export default {
  props: ["infoData"],
  data() {
    return {
      DynamicAreaByPlanidActive: "计划关联空域",
      TaskAreaByPlanidActive: null,

      AirportControlZoneByPlanidActive: null,
      BranchAirportByPlanidActive: null,
      fillcolor: "#fff000",
      strokecolor: "#fff",
      opacity: 0.5,
    };
  },
  watch: {},

  computed: {
    ...mapGetters({
      planreleMap: "planrele/planreleMap",
      taskMap: "planrele/taskMap",
      meteoToken: "meteoToken",
      userId: "userId",
      type: "type",
      currentMap: "switchMap/currentMap",
      infoId: "station_plan/infoId",
    }),
  },
  methods: {
    ...mapActions({
      startDataDrawAction: "drawMap/startDataDrawAction",
      stopDrawAction: "drawMap/stopDrawAction",
    }),
    closeAll() {
      this.delDynamicAreaByPlanid();
      this.delTaskAreaByPlanid();
      this.delAirportControlZoneByPlanid();
    },
    choiceDynamicAreaByPlanid(item) {
      if (!this.DynamicAreaByPlanidActive) {
        this.DynamicAreaByPlanidActive = item;
        this.getDynamicAreaByPlanidList();
      } else {
        this.DynamicAreaByPlanidActive = null;
        this.delDynamicAreaByPlanid();
      }
    },
    choiceAirportControlZoneByPlanid(item) {
      if (!this.AirportControlZoneByPlanidActive) {
        this.AirportControlZoneByPlanidActive = item;
        this.getAirportControlZoneByPlanidList({ id: this.infoId });
      } else {
        this.AirportControlZoneByPlanidActive = null;
        this.delAirportControlZoneByPlanid();
      }
    },
    choiceBranchAirportByPlanid(item) {
      if (!this.BranchAirportByPlanidActive) {
        this.BranchAirportByPlanidActive = item;
        this.getBranchAirportByPlanidList({ id: this.infoId });
      } else {
        this.BranchAirportByPlanidActive = null;
        this.delBranchAirportByPlanid();
      }
    },
    tDColor(status) {
      if (status === 0) {
        return "#cfa23d";
      } else if (status === 1) {
        return "#175218";
      } else if (status === 2) {
        return "#ffeb3b";
      }
    },

    async getBranchAirportByPlanidList() {
      let res = await getBranchAirportByPlanid({ id: this.infoId });
      res.forEach((item) => {
        if (item.airportcontrolzone) {
          let latlngs = [];
          item.airportcontrolzone.points.forEach((i) => {
            let latlng = [i.la, i.lo];
            latlngs.push(latlng);
          });

          var drawLayer = L.polygon(latlngs, {
            fillOpacity: 0.2,
            fillColor: item.airportcontrolzone.fillcolor,
            color: item.airportcontrolzone.strokecolor,
            weight: 2,
            opacity: item.airportcontrolzone.opacity,
          })
            .bindPopup(
              ` 
            <p>区域名称：${item.airportcontrolzone.title}</p>
            <p>区域代码：${item.airportcontrolzone.code}</p>
          `
            )
            .addTo(this.planreleMap.BranchAirportByPlanid);
        } else {
        }
      });
    },

    async getAirportControlZoneByPlanidList() {
      let res = await getAirportControlZoneByPlanid({ id: this.infoId });
      res.forEach((item) => {
        let latlngs = [];
        item.airportcontrolzone.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });
        var drawLayer = L.polygon(latlngs, {
          fillOpacity: 0.2,
          fillColor: item.airportcontrolzone.fillcolor,
          color: item.airportcontrolzone.strokecolor,
          weight: 2,
          opacity: item.airportcontrolzone.opacity,
        })
          .bindPopup(
            ` 
            <p>区域名称：${item.airportcontrolzone.title}</p>
            <p>区域代码：${item.airportcontrolzone.code}</p>
          `
          )
          .addTo(this.planreleMap.AirportControlZoneByPlanid);
      });
    },
    delAirportControlZoneByPlanid() {
      this.planreleMap.AirportControlZoneByPlanid.clearLayers();
    },
    delBranchAirportByPlanid() {
      this.planreleMap.BranchAirportByPlanid.clearLayers();
    },
    async getDynamicAreaByPlanidList() {
      let res = await getDynamicAreaByPlanid({
        id: this.infoId,
      });
      res.forEach((item) => {
        let latlngs = [];
        item.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });
        let color = this.tDColor(Number(item.type));
        var drawLayer = L.polygon(latlngs, {
          fillOpacity: 0.2,
          fillColor: color,
          color: color,
          weight: 2,
          opacity: item.opacity,
        })
          .bindPopup(
            ` 
            <p>区域代码：${item.code}</p>
          `
          )
          .addTo(this.planreleMap.DynamicAreaByPlanid);
      });
    },

    // 任务·关联空域
    choiceTaskAreaByPlanid(items) {
      if (!this.TaskAreaByPlanidActive) {
        this.TaskAreaByPlanidActive = items;
        this.getTaskAreaByPlanidList(this.infoData.flightmissionid);
      } else {
        this.TaskAreaByPlanidActive = null;
        this.delTaskAreaByPlanid();
      }
    },

    async getTaskAreaByPlanidList(id) {
      let res = await getTaskDetail(id);
      res.flightmission.routes.forEach((item) => {
        let arrbox = [];
        item.routepoints.forEach((i) => {
          let arr = [i.la, i.lo];
          arrbox.push(arr);
        });
        L.polyline(arrbox, {
          color: "red",
          smoothFactor: 2,
        })
          .bindPopup(
            `
            <p>区域名称：${item.title}</p>
          `
          )
          .addTo(this.taskMap.TaskAreaByPlanid);
      });
      res.flightmission.roundareas.forEach((item) => {
        let aroundTask = [item.la, item.lo];
        L.circle(aroundTask, {
          radius: item.radius * 1000,
          color: "rgb(109, 211, 62)",
          title: item.title,
        })
          .bindPopup(
            `
            <p>区域名称：${item.title}</p>
          `
          )
          .addTo(this.taskMap.TaskAreaByPlanid);
      });
      res.flightmission.polygonareas.forEach((item) => {
        let arrbox = [];
        item.polygonpoints.forEach((i) => {
          let arr = [i.la, i.lo];
          arrbox.push(arr);
        });
        console.log(arrbox);
        L.polygon(arrbox, {
          title: item.title,
          fillOpacity: 0.2,
          fillColor: "rgb(109, 211, 62)",
          color: "rgb(109, 211, 62)",
          weight: 2,
          opacity: 0.5,
        })
          .bindPopup(
            `
            <p>区域名称：${item.title}</p>
          `
          )
          .addTo(this.taskMap.TaskAreaByPlanid);
      });
    },

    delDynamicAreaByPlanid() {
      this.planreleMap.DynamicAreaByPlanid.clearLayers();
    },
    delTaskAreaByPlanid() {
      this.taskMap.TaskAreaByPlanid.clearLayers();
    },
  },
  mounted() {
    this.closeAll();
    this.getDynamicAreaByPlanidList();
  },
  beforeDestroy() {
    this.closeAll();
  },
};
</script>

<style lang="less" scoped>
.controlbox {
  position: relative;
}
.featureControl {
  // background: url(../assets/img/no_select.png) no-repeat 18px 10px;
  background-color: rgb(62, 62, 211) !important;
  box-shadow: 6px 0px 8px rgba(25, 34, 34, 0.53);
}

.featureactive {
  // background: url(../assets/img/iselect.png) no-repeat 18px 10px;
  color: #2cfdff !important;
  background-color: rgb(62, 62, 211) !important;
  // box-shadow: 6px 0px 8px rgba(25, 34, 34, 0.53);
}

.link {
  cursor: pointer;
  display: block;
  // padding: 8px 15px 5px 35px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  color: #fff;
  font-size: 12px;
  position: relative;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.layerControlListDiv {
  background-color: var(--sidebar-defalut-bg);
  width: 120px;
  position: absolute;
  left: -120px;
  top: 0px;
}
.meteListDiv {
  width: 120px;
  position: absolute;
  left: -90px;
  top: -319.5px;
}
.watch {
  background-color: var(--sidebar-defalut-bg);
  width: 120px;
  position: absolute;
  left: 120px;
  top: 0px;
}
.airpositionDataSourceUl li {
  height: 29px;
  padding-left: 10px;
}
.smt_box2Li_title {
  color: #fff;
}
</style>